
import { ArrowLeft } from 'lucide-react'
import { LLMSettings } from '../../../../components/LLMSettings'
import { useLLM } from '../../../../hooks/useLLM'

interface SettingsViewProps {
    settingsTab: 'llm' | 'voice'
    setSettingsTab: (tab: 'llm' | 'voice') => void
    setShowSettings: (show: boolean) => void
    isFullscreen: boolean
}

export const SettingsView: React.FC<SettingsViewProps> = ({
    setShowSettings,
    isFullscreen,
}) => {
    const llm = useLLM()

    return (
        <div className="flex-1 flex flex-col bg-white dark:bg-black overflow-hidden relative w-full h-full">
            <div className="border-b border-gray-200 dark:border-gray-800 shrink-0">
                <div className={`p-4 ${isFullscreen ? 'max-w-4xl mx-auto' : ''}`}>
                    <div className="flex items-center gap-3 mb-3 md:hidden">
                        <button
                            onClick={() => setShowSettings(false)}
                            className="p-2 -ml-2 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg transition-colors"
                            aria-label="Voltar ao chat"
                        >
                            <ArrowLeft className="w-5 h-5 text-gray-700 dark:text-gray-300" />
                        </button>
                        <h3 className="text-base font-semibold text-gray-900 dark:text-white">Configurações</h3>
                    </div>

                    <div className="md:flex items-center justify-between">
                        <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300 hidden md:block">
                            Cérebro da IA (LLM)
                        </h4>
                        <div className="hidden lg:flex items-center gap-2 px-3 py-1 bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800/30 rounded-full">
                            <div className="w-1.5 h-1.5 rounded-full bg-blue-500 animate-pulse" />
                            <span className="text-[10px] uppercase tracking-wider font-bold text-blue-600 dark:text-blue-400">Ambiente de Alta Performance</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex-1 overflow-y-auto touch-pan-y">
                <div className={`p-6 space-y-6 ${isFullscreen ? 'max-w-4xl mx-auto' : ''}`}>
                    <LLMSettings
                        currentConfig={llm.config}
                        onConfigChange={llm.updateConfig}
                    />
                </div>
            </div>
        </div>
    )
}
